import '../../styles/modules/oneStyleGuide.scss';

class OneStyleGuideView {
    constructor(settings) {
        console.log(`Init OneStyleGuide ...`);
        console.log(settings);
    }
}

// Define the module here 
const OneStyleGuide = {
	init: function (settings) {
		
		// If using Backbone View
		return new OneStyleGuideView(settings);
		
		// If not using Backbone View
		// return this;
	}
}

// Output the module
export default OneStyleGuide;

